<template>
	<div>
		<div v-if="isReconnect" class="reconnect-feedback"> Reconectando... </div>
		<section>
			<div id="spearhead"> 
				<div v-if="protocol || personContact.name || personContact.phone || queue" class="d-flex">
					<div class="spearhead-element">
						<span><i class="fas fa-clipboard"></i><b>Protocolo</b></span>
						<p v-if="protocol">{{ protocol }}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element">
						<span><i class="fas fa-user"></i><b>Cliente</b></span>
						<p v-if="personContact.name">{{ personContact.name }}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element">
						<span><i class="fas fa-phone"></i><b>Telefone</b></span>
						<p v-if="personContact.phone">{{ personContact.phone }}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element">
						<span><i class="fas fa-headset"></i><b>Fila de Atendimento</b></span>
						<p v-if="queue">{{ queue }}</p>
						<p v-else>----------</p>
					</div>
					<div class="spearhead-element">
						<span><i class="fas fa-clock"></i><b>Fim da Sessão</b></span>
						<p v-if="session">{{ formatSessionDate(session) }}</p>
						<p v-else>----------</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import validarTel from '../../store/modules/validarTel'
import socket from './../../modules/realtime/service/service'

export default {
	data() {
		return {
			interval: '',
			time: '',
			timeFormat: '',
			protocol: '',
			personContact: {
				name: '',
				phone: '',
			},
			queue: '',
			loteamento: '',
			cpfcnpj: '',
			session: null,
			hasData: false
		}
	},
	methods: {
		normalizePhone(phone) {
			if (!phone) return null
			let clean = String(phone).trim().replace(/\s+/g, '')
			if (clean.startsWith('5555')) clean = clean.slice(2)
			return clean
		},

		async setClientData(client) {
			if (!client || !Object.keys(client).length) return

			let clientName = ''
			let phoneEdited = ''

			const sessionValue =
				client?.sessionDate ||
				client?.session_date ||
				client?.session ||
				client?.sessionEnd ||
				null

			if (sessionValue) this.session = sessionValue

			if (this.getPhone) {
				if (client?.type === 'chat' && client?.phone) {
					let phoneArr = client.phone.split('@')
					phoneEdited = validarTel.formata_telefone(phoneArr[0].substr(2))
				}

				let nameFromState = (client?.client || client?.name || '').trim()

				this.personContact = {
					name: nameFromState,
					phone: phoneEdited || validarTel.formata_telefone(this.getPhone),
				}

				this.queue = (client?.queue === 'entrante') ? 'Atendimento Ativo' : (client?.queue || this.queue)
				this.protocol = client?.protocol || client?.Protocolo || this.protocol

				if (!nameFromState) {
					const rawClientId = client?.phone || ''

					const normalizeWhatsKey = (v) => {
						if (!v) return null
						let clean = String(v).trim().replace(/\s+/g, '')
						if (clean.startsWith('5555')) clean = clean.slice(2)
						return clean
					}

					const shareValue = normalizeWhatsKey(rawClientId)

					if (shareValue) {
						try {
							const { data } = await axios(`/share-client-cnpj?share=${encodeURIComponent(shareValue)}`)
							this.personContact.name = (data && data.length && data[0]?.name) ? data[0].name : '---'
						} catch {
							this.personContact.name = '---'
						}
					} else {
						this.personContact.name = '---'
					}
				}
			}

			if (client?.type === 'phone') {
				const rawPhone = client?.phone || null
				const phoneNormalized = this.normalizePhone(rawPhone)

				this.loteamento = client?.loteamento || this.loteamento
				this.cpfcnpj = client?.cpfcnpj || this.cpfcnpj
				this.protocol = client?.Protocolo || this.protocol
				this.queue = client?.Registro || this.queue

				if (!phoneNormalized) {
					this.personContact = {
						name: client?.name || client?.client || '',
						phone: rawPhone || ''
					}
					return
				}

				try {
					const response = await axios(`/share-client-cnpj?share=${encodeURIComponent(phoneNormalized)}`)
					clientName = response?.data?.length ? response.data[0].name : phoneNormalized
				} catch {
					clientName = phoneNormalized
				}

				this.personContact = {
					name: clientName,
					phone: rawPhone
				}
			}
		},

		formatSessionDate(date) {
			if (!date) return ''
			return window.moment(date).format('DD/MM/YYYY HH:mm:ss')
		}
	},
	computed: {
		...mapGetters(['isReconnect', 'getDataTransduson', 'getPhone', 'getDataLog']),
	},
	watch: {
		getDataTransduson(val) {
			if (!val || Object.keys(val).length === 0) {
				this.personContact = { name: '', phone: '' }
				this.protocol = ''
				this.queue = ''
				this.session = null
				this.hasData = false
				return
			}

			this.setClientData(val)
			localStorage.setItem('clienteAtual', JSON.stringify(val))
			this.hasData = true
		},
		getDataLog(myLog) {
			this.setClientData(myLog)
		}
	},
	mounted() {
		if (!localStorage.getItem('clienteAtual')) {
			this.hasData = false
			return
		}

		const clienteAtual = JSON.parse(localStorage.getItem('clienteAtual'))
		if (Object.keys(clienteAtual).length) {
			this.hasData = true
			this.setClientData(clienteAtual)
		}
	}
}
</script>

<style scoped>
#spearhead{
	display: flex;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1;
	border-radius: 0px 0px 14px 14px;
	font-size: 11px;
	background-color: white;
	margin: 2px;
	box-shadow: -1px 5px 7px 0px #9f9999;
	transition: 0.7s;
	height: max-content;
}
.spearhead-element{
	display: flex;
	flex-direction: column;
	text-align: center;
	border-right: 1px solid lightgray;
	border-left: 1px solid lightgray;
	padding: 0px 10px;
}
.spearhead-element span{
	font-size: 12px;
}
.reconnect-feedback{
	display: flex;
	justify-content: center;
	width: 100%;
	background-color: gray;
	color: white;
}
p{
	margin: 0 5px;
}
</style>
